import {
  emptyString,
  globalConstants,
  individualStoreProfileConstants,
} from "../../constants";

const { SUCCESS } = globalConstants;
const {
  FR_ROUTE,
  BRAND_ID,
  LOCATION_ID,
  FETCH_GENERAL_DATA,
  RESET_STORE_PROFILE,
} = individualStoreProfileConstants;

const initialState = {
  profileData: {},
  locationId: emptyString,
  brandId: emptyString,
  frRoute: false,
};

export const individualStoreProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GENERAL_DATA + SUCCESS:
      return { ...state, profileData: action.data };
    case LOCATION_ID + SUCCESS:
      return { ...state, locationId: action.data };
    case BRAND_ID + SUCCESS:
      return { ...state, brandId: action.data };
    case FR_ROUTE + SUCCESS:
      return { ...state, frRoute: action.data };
    case RESET_STORE_PROFILE + SUCCESS:
      return { ...state, profileData: action.data };
    default:
      return state;
  }
};
